'use client'
import styled from "styled-components";
import { mq, vw,designGrid, defaultGrid, font18_22, getP53 } from "@/styles";


export const MainContents = styled.main`
  ${designGrid({})}
  padding: 0 ${vw(20, 'mobile')};
  margin-bottom: ${vw(48, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    margin-bottom: ${vw(48, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    margin-bottom: ${vw(60, 'desktop')};
  }

  ${mq.greaterThan('tablet')} {
    margin-bottom: 60px;
  }

  ${mq.greaterThan('desktop')} {
    padding: 0;
  }

  .text-wrapper p {
    ${font18_22(true)}
    font-weight: 400!important;
    margin-bottom: ${vw(15, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-bottom: ${vw(15, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      ${font18_22(false)}
      margin-bottom: ${vw(15, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-bottom: 15px;
    }
  }

  ul {
    margin-top: ${vw(18, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-top: ${vw(18, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      margin-top: ${vw(18, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-top: 18px;
    }

    li {
      margin-bottom: ${vw(18, 'mobile')};

      &:last-child {
        margin-bottom: 0;
      }
    }

    * {
      ${font18_22(true)}
      font-weight: 400!important;

      ${mq.greaterThan('tablet')} {
        ${font18_22(false)}
      }
    }

    li {
      ${mq.greaterThan('tablet')} {
        margin-bottom: ${vw(18, 'desktop')};

        &:last-child {
          margin-bottom: 0;
        }
      }

      ${mq.greaterThan('desktop')} {
        margin-bottom: 18px;
      }
    }
  }

  section {
    > article {
      &.text {
        ${mq.greaterThan('tablet')} {
          padding: 0;
        }

        .text-wrapper > *:not(h2) {
          ${mq.greaterThan('tablet')} {
            padding: 0 ${vw(defaultGrid.desktop.columns.width, 'desktop')};
          }

          ${mq.greaterThan('desktop')} {
            padding: 0 ${defaultGrid.desktop.columns.width}px;
          }
        }
      }
    }
  }

  .text-wrapper h2 {
    ${getP53()}
    font-family: var(--font-platform);
    text-align: center;
    margin-bottom: ${vw(30, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-bottom: ${vw(30, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      margin-bottom: ${vw(60, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-bottom: 60px;
    }
  }

  h3 {
    margin-bottom: ${vw(15, 'mobile')};
    margin-top: ${vw(60, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-bottom: ${vw(15, 'tablet')};
      margin-top: ${vw(60, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      margin-bottom: ${vw(15, 'desktop')};
      margin-top: ${vw(60, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-bottom: 15px;
      margin-top: 60px;
    }
  }

  h3, strong {
    ${font18_22(true)}
    font-weight: 400!important;

    ${mq.greaterThan('tablet')} {
      ${font18_22(false)}
    }

    + p {
      margin-top: 0!important;
    }
  }
`
